import React, { Suspense, lazy, useEffect, useState } from 'react'
import { render } from 'react-dom'
import RModal from 'react-modal'

import axios from 'axios'
import ProgressLoader from './ey-components-v2/progress-loader/progress-loader'
import { getBackendUrl } from './backend-config'

const RootApp = lazy(() => import('./root-app'))

RModal.setAppElement('#root')
const Root = () => {
    const [appConfig, setAppConfig] = useState(false)
    useEffect(() => {
        const fetchData = async () => {
            const backendUrl = getBackendUrl()
            const config = await axios.get(`${backendUrl}/api/v1/frontend-app-config`)
            setAppConfig(true)
            sessionStorage.setItem('app-config', config.data.appConfig)
            sessionStorage.setItem('app-other-config', config.data.appOtherConfig)
        }
        fetchData()
    }, [])
    return (
        <>{appConfig &&
            <Suspense fallback={<ProgressLoader show={true} style={{ top: window.innerHeight / 2, left: window.innerWidth / 2 - 50 }} />}>
                <RootApp />
            </Suspense>
        }
        </>
    )
}

render(<Root />, document.getElementById('root'))
